import React from 'react';

import {
  Button as BsButton,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap-5';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export type ButtonProps = React.ComponentPropsWithoutRef<typeof BsButton> & {
  disabledTooltip?: React.ReactNode;
  icon?: FontAwesomeIconProps['icon'];
  iconRight?: FontAwesomeIconProps['icon'];
  label?: string;
  outlined?: boolean;
  plain?: boolean;
  tooltip?: React.ReactNode;
  tooltipProps?: object;
};

export default function Button({
  children,
  className,
  disabled,
  disabledTooltip,
  href,
  icon,
  iconRight,
  label,
  outlined,
  plain,
  tooltip,
  tooltipProps,
  variant: variantProp = 'primary',
  onClick = () => {},
  ...otherProps
}: ButtonProps) {
  let variant = variantProp;
  if (outlined) {
    variant = 'outline';
  } else if (plain) {
    variant = 'ghost';
  }

  const hasDisabledTooltip = disabled && disabledTooltip;
  
  const props = {
    ...otherProps,
    variant,
    className,
    disabled,
    'aria-label': otherProps['aria-label'] || label,
    ...((!hasDisabledTooltip) && { onClick }),
  };

  let button = (
    <BsButton {...props}>
      {icon && <FontAwesomeIcon icon={icon} />}
      {children || label}
      {iconRight && <FontAwesomeIcon icon={iconRight} />}
    </BsButton>
  );

  if (href) {
    button = <a href={href}>{button}</a>;
  }

  if (hasDisabledTooltip || tooltip) {
    button = (
      <OverlayTrigger
        overlay={
          <Tooltip id="disabled-button-tooltip">
            {hasDisabledTooltip ? disabledTooltip : tooltip}
          </Tooltip>
        }
        placement="bottom"
        {...tooltipProps}
      >
        <span>{button}</span>
      </OverlayTrigger>
    );
  }

  return button;
}
